function generatePublicKey(key: string) {
  /**
   * TabaPay and Green Dot require to use a public key to encrypt the card data
   * this should have a specific format before we apply the encryption
   */
  return `-----BEGIN PUBLIC KEY-----
${key}
-----END PUBLIC KEY-----`;
}

export default generatePublicKey;
